"use strict";

(() => {
  const handleCloseClick = (event) => {
    const closeBtn = event.target.closest('#mini-cart .line-item__close[data-line-id]');
    if (!closeBtn || !window.themeVariables) return;

    event.preventDefault();

    const lineItem = closeBtn.closest("line-item");
    const bridge = lineItem?.querySelector("line-item-quantity");
    const lineId = closeBtn.dataset.lineId;
    const quantity = parseInt(closeBtn.dataset.targetQuantity, 10);

    if (!bridge?._updateFromLink || !lineId || !(quantity >= 0)) return;

    const url = `${window.themeVariables.routes.cartChangeUrl}?quantity=${quantity}&id=${encodeURIComponent(lineId)}`;

    bridge._updateFromLink(url);
  };

  document.addEventListener("click", handleCloseClick);
})();
